import { generateBooleanSchema, generateColorSchema, generateNumberSchema, generateRootObjectSchema, generateStringSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";

export const specification = new BaseAtomSpec("NV Play Video Highlights", generateRootObjectSchema({
  container: generateAtomContainerSchema(),
  matchIdType: generateStringSchema("Match ID Type", "The type of ID being used in the Match IDs field.", {
    choices: ['nvplay', 'opta'],
    choiceTitles: ['NV Play', 'Opta'],
    defaultValue: 'nvplay',
  }),
  matchIds: generateStringSchema("Match IDs", "The NV Play or Opta match ID(s), comma-separated for videos from multiple matches. IDs that do not exist are ignored; if none exist the list of videos will be empty. If not set, falls back to the gameId query-string parameter from the page URL."),
  format: generateStringSchema("Format", "Show all videos in a single list, or include a match filter/drop-down.", {
    choices: ['single', 'multiple'],
    choiceTitles: ['Single List', 'Multiple (with match filter)'],
    defaultValue: 'single',
  }),
  layoutType: generateStringSchema("Layout Type", "Show videos in a responsive grid or a single vertical column.", {
    choices: ['single', 'grid'],
    choiceTitles: ['Single Column', 'Grid'],
    defaultValue: 'single',
  }),
  competition: generateStringSchema("Competition", "An optional name of the competition to be displayed at the top of the widget."),
  keyMomentsOnly: generateBooleanSchema("Key Moments Only", "Limit the types of video highlights to individual batting and bowling milestones and identified key moments."),
  pollSeconds: generateNumberSchema("Poll Seconds", "The number of seconds to wait before refreshing data. If empty or 0, data will not update until the page is reloaded."),
  pageSize: generateNumberSchema("Page Size", "The maximum number of videos to display.", {
    defaultValue: 50,
  }),
  textColor: generateColorSchema("Text Color", "Foreground text color throughout the widget.", {
    defaultValue: '#ffffff',
  }),
  dropdownBorderColor: generateColorSchema("Dropdown Border Color", "Color of the underline beneath the match/player filter dropdowns.", {
    defaultValue: '#ffffff',
  }),
  dropdownOptionsTextColor: generateColorSchema("Dropdown Options Text Color", "Text color of the options inside an open filter dropdown.", {
    defaultValue: '#000000',
  }),
  mediaBackgroundColor: generateColorSchema("Video Background Color", "Background color of a video tile.", {
    defaultValue: '#ffffff',
  }),
  mediaTextColor: generateColorSchema("Video Text Color", "Text color inside a video tile.", {
    defaultValue: '#000000',
  }),
  filterActiveBackgroundColor: generateColorSchema("Active Filter Background Color", "Background color of the selected filter button.", {
    defaultValue: '#ffffff',
  }),
  filterActiveTextColor: generateColorSchema("Active Filter Text Color", "Text color of the selected filter button.", {
    defaultValue: '#091f38',
  }),
}));
